import { Text } from '@mantine/core';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import StandalonePreview from './StandalonePreview';
import usePreviewRecommender from './usePreviewRecommender';

// The layout editor's preview: the block in an iframe of its own, built by the
// SDK. TemplateForm decides who gets one — a hand-written web layout does not,
// since an iframe here has none of the shop's css and so misleads by
// construction; it is looked at on the customer's own site instead (see
// EditOnMySite). A body that will not compile is now reported by the frame; what
// is left here is a body the wizard transform itself cannot read.
const TemplatePreview = ({ template }) => {
  const { previewRecommender, previewError, fetchError, loading } = usePreviewRecommender(template);

  if (fetchError) {
    return <ErrorMessage message={fetchError.message} />;
  }

  if (!template || loading) {
    return <Spinner />;
  }

  if (previewError) {
    return <Text size="sm">{previewError}</Text>;
  }

  return <StandalonePreview recommender={previewRecommender} scope={template.scope} />;
};

export default TemplatePreview;
